export const DID_NOT_SHOW = 'did_not_show';
export const DELETE_TEXT = 'Delete';
export const DELETE_VIDEO_TEXT = 'Delete Video';

export const TABS_OPTIONS = {
  DEMOGRAPHICS: 'demographics',
  'CONSENT-FORM': 'consent-form',
  SCREENER: 'screener',
  EMPLOYMENT: 'employment',
};
